// src/screens/sales/document/components/list/List.tsx
import { DocumentInterface } from '../../../../../common/types/interfaces'
import { Item } from '../item/Item'
import classes from './List.module.sass'

type Props = {
  startEdit: (el: DocumentInterface) => void
  showDetails: (el: DocumentInterface) => void
  onDownload: (el: DocumentInterface) => void
  list: DocumentInterface[]
  loading: boolean
  getPreviewUrl: (el: DocumentInterface) => string | undefined
}

export const List = ({
  startEdit,
  list,
  showDetails,
  loading,
  onDownload,
  getPreviewUrl,
}: Props) => {
  return (
    <div className={classes.container}>
      {!list?.length && !loading ? (
        <div className={classes.Message}>Нет документов</div>
      ) : (
        list.map((el) => (
          <Item
            el={el}
            startEdit={startEdit}
            showDetails={showDetails}
            onDownload={onDownload}
            key={el.id}
            previewUrl={getPreviewUrl(el)}
          />
        ))
      )}
    </div>
  )
}
